import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'

import Option from './Option'
import { QuestionWrapper, QuestionText, QuestionTextSpan, OptionsWrapper, QuestionBackLink, QuestionBackLinkEmpty } from '../StyledComponents/IntroQuestions/Question'

class OptionsQuestion extends Component {
    render() {
        const {
            text, fullWidth, options, onAnswerClicked, onBackClicked, isFirst,
        } = this.props

        const optionsView = options.map(option => (
            <Option
                key={option.label}
                data={option}
                fullWidth={fullWidth}
                onOptionClicked={onAnswerClicked}
            />
        ))

        const backLink = isFirst
            ? <QuestionBackLinkEmpty />
            : (
                <QuestionBackLink onClick={onBackClicked} >
                    <FontAwesome
                        name="arrow-left"
                        size="lg"
                    />
                </QuestionBackLink>
            )

        return (
            <QuestionWrapper>
                {backLink}
                <QuestionText>
                    <QuestionTextSpan>{text}</QuestionTextSpan>
                </QuestionText>
                <OptionsWrapper>
                    {optionsView}
                </OptionsWrapper>
            </QuestionWrapper>
        )
    }
}

export default OptionsQuestion



// WEBPACK FOOTER //
// ./src/components/IntroQuestions/OptionsQuestion.js